// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--1868c","languageSelector":"styles-module--language-selector--adc81","hollow":"styles-module--hollow--a5023"};